const calendarPrices = {
    arrivalDate: null,
    departureDate: null,
    urlMonth: null,
    calculateTotalPriceUrl: null,
    monthPricesIdSelector: null,
    calendarTableIdSelector: null,
    persons: null,

    init(options) {
        const self = this;
        self.arrivalDate = options.arrivalDate !== null ? self.parseDate(options.arrivalDate) : null;
        self.departureDate = options.departureDate !== null ? self.parseDate(options.departureDate) : null;

        self.urlMonth = options.urlMonth;
        self.calculateTotalPriceUrl = options.calculateTotalPriceUrl;

        self.monthPricesIdSelector = '#monthPrices';
        self.calendarTableIdSelector = '#calendarTable';
        self.persons = $('#calendarTable').data('persons');

        // EVENTI
        // ovaj klik na datum nije radio dok je bio event na $(document).on...
        $('#pageWrap').on('click', '#calendarTable td.preferred', function selectPreferredDate() {
            self.actOnSelected(this, self);
        });

        self.suggestDates();

        $(document)
            .on('click', '.js-changeMonth', function changeMonth(e) { // Promjena prikaza mjeseca
                e.preventDefault();
                e.stopPropagation();
                self.changeMonth(self, $(this).data('month'));
            })
            .on('click', '.js-changePersons', function changePersons() { // Promjena broja osoba
                self.changePersons($(this).data('persons'));
                self.changeMonth(self, $(this).data('month'));
            })
            .on('swipeleft', self.monthPricesIdSelector, (e) => { // Swipe-anje kalendara u lijevo
                e.preventDefault();
                e.stopPropagation();
                self.changeMonth(self, $('#monthNext').data('month'));
            })
            .on('swiperight', self.monthPricesIdSelector, (e) => { // Swipe-anje kalendara u desno
                e.preventDefault();
                e.stopPropagation();
                self.changeMonth(self, $('#monthPrevious').data('month'));
            });

        self.toggleInfoNote();
    },
    actOnSelected(item) {
        const self = this;
        const selectedDay = $(item).attr('id');
        let selectedPrice = $(item).data('day-price');
        if (selectedPrice === undefined) {
            selectedPrice = 0;
        }

        const selectedDate = self.parseDate(selectedDay.substr(6, 10));

        if (self.arrivalDate !== null && self.departureDate !== null) {
            self.arrivalDate = null;
            self.departureDate = null;
        }

        if (self.arrivalDate === null) {
            if (!$(item).hasClass('unavail_start')) {
                // clear prevous selected dates
                $(item).parent().parent().find('.selected')
                    .removeClass('selected');

                self.arrivalDate = selectedDate;
                $(item).addClass('selected');
                self.departureDate = null;
            }
        } else if (self.arrivalDate !== null && self.departureDate === null) {
            if (!$(item).hasClass('unavail_end')) {
                if (selectedDate < self.arrivalDate) {
                    // izabran manji dan od prvotno izabranog
                    self.departureDate = self.arrivalDate;
                    self.arrivalDate = selectedDate;
                    self.getCalculation();
                } else if (selectedDate > self.arrivalDate) {
                    // izabran datum veci od prvotno izabranog
                    self.departureDate = selectedDate;
                    self.getCalculation();
                } else {
                    // izabran isti datum
                    self.departureDate = null;
                    self.arrivalDate = null;
                    $(item).parent().parent().find('.selected')
                        .removeClass('selected');
                }
            }
        }
    },
    changePersons(persons) {
        const self = this;
        self.persons = persons;
        if (self.arrivalDate !== null && self.departureDate !== null) {
            self.getCalculation();
        } else if (self.arrivalDate !== null && self.departureDate === null) {
            self.arrivalDate = null;
        }
    },
    // AJAX poziv izračuna totalne cijene
    getCalculation() {
        const self = this;
        let { calculateTotalPriceUrl } = self;
        calculateTotalPriceUrl = calculateTotalPriceUrl.replace(
            '__ARRIVAL_DATE__',
            self.arrivalDate.toISOString().substr(0, 10),
        );
        calculateTotalPriceUrl = calculateTotalPriceUrl.replace(
            '__DEPARTURE_DATE__',
            self.departureDate.toISOString().substr(0, 10),
        );
        calculateTotalPriceUrl = calculateTotalPriceUrl.replace('__ADULTS__', self.persons);

        $.ajax({
            type: 'POST',
            url: calculateTotalPriceUrl,
            data: { searchReturnParameters: $('#searchReturnParameters').data('searchparameters') },
            success(data) {
                if (data.status) {
                    $('#reservationOverview').html(data.reservationOverviewHtml);
                    // colour selected period
                    $(self.calendarTableIdSelector).find('td').each((key, tdItem) => {
                        const selectedDay = $(tdItem).attr('id');
                        const selectedDate = self.parseDate(selectedDay.substr(6, 10));
                        if (selectedDate >= self.arrivalDate && selectedDate <= self.departureDate) {
                            $(tdItem).addClass('selected');
                        }
                    });
                    self.toggleInfoNote();
                }
            },
        });
    },
    changeMonth(self, date) {
        const $loaderCalendar = $('#loaderCalendar');
        $loaderCalendar.show();
        const arrivalDate = self.arrivalDate !== null
            ? self.arrivalDate.toISOString().substr(0, 10)
            : null;
        const departureDate = self.departureDate !== null
            ? self.departureDate.toISOString().substr(0, 10)
            : null;
        let ajaxUrl = self.urlMonth.replace('__DATE__', date);
        ajaxUrl = ajaxUrl.replace('__PERSONS__', self.persons);
        let query = {};
        if (arrivalDate !== null && departureDate !== null) {
            query = { arrival: arrivalDate, departure: departureDate };
        }

        $.ajax({
            type: 'GET',
            url: ajaxUrl,
            data: query,
            dataType: 'html',
            success(data) {
                if (data !== '') {
                    $(self.monthPricesIdSelector).html(data);
                    // ako je postavljen samo arrival date označi ga
                    if (self.arrivalDate !== null && self.departureDate === null) {
                        $(self.calendarTableIdSelector)
                            .find(`#tabDay${self.arrivalDate.toISOString().substr(0, 10)}`)
                            .addClass('selected');
                    }
                }
                $loaderCalendar.hide();
            },
        });
    },
    // parse a date in yyyy-mm-dd format
    parseDate(stringDate) {
        const parts = stringDate.match(/(\d+)/g);
        return new Date(parts[0], parts[1] - 1, parts[2], 2); // months are 0-based
    },
    suggestDates() {
        const self = this;
        const suggestedDates = document.querySelectorAll('.suggestedDate');

        suggestedDates.forEach((suggestedDate) => suggestedDate.addEventListener('click', () => {
            const suggestedArrival = suggestedDate.getAttribute('data-from');
            const suggestedDeparture = suggestedDate.getAttribute('data-to');

            self.arrivalDate = self.parseDate(suggestedArrival);
            self.departureDate = self.parseDate(suggestedDeparture);

            const firstDayOfArrivalMonth = `${suggestedArrival.slice(0, suggestedArrival.length - 2)}01`;

            self.changeMonth(self, firstDayOfArrivalMonth);
            self.getCalculation();
        }));
    },
    toggleInfoNote() {
        $(document).on('click', '.infoNote', function info() {
            if ($(this).next('.revealInfo').length) {
                $(this).next('.revealInfo').slideToggle(200);
            } else {
                $(this).parent().siblings('.revealInfo').slideToggle(200);
            }
        });
    },
};

export default calendarPrices;
